import { cashierCtrl } from 'modules/POS/Cashier/cashier.controller';
import TicketButton, { TicketButtonTypes } from '../TicketButton';
import ModalSplitTicket, { useModalSplitTicket } from './ModalSplitTicket';
type Props = {
  value?: string;
};
const SplitTicket = ({ }: Props) => {
  const ref = useModalSplitTicket();
  const onSplitTicket = () => cashierCtrl.saveTicketPaymentWithCallBack((billId) => ref.current?.open(billId || ''));
  const onComplete = (billId: string) => cashierCtrl.switchTicket(billId);

  return (
    <>
      <TicketButton
        type={TicketButtonTypes.SPLIT_TICKET}
        onClick={onSplitTicket}
      />
      <ModalSplitTicket ref={ref} onComplete={onComplete} />
    </>
  );
};

export default SplitTicket;
